// extracted by mini-css-extract-plugin
export default {"root":"xfeNe6UOG4Tw2yBoQmFk","content":"e7FQ4yTE9bMB0oO8ar63"};